import { Inject } from 'inversify-props'
import { CategoriaGlobalMarketplace, Page } from '@/models'
import { AxiosRequestConfig } from 'axios'
import type { MarketplaceServiceAdapter } from './adapter'

export class FindCategoriaGlobalMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	findAll = async (params: any, config?: AxiosRequestConfig): Promise<Page<CategoriaGlobalMarketplace>> =>
		this.marketplaceAdapter.findAllCategoriasGlobais(params, config)

}